<template>
  <el-input
    v-model="phone.number"
    :type="isMobile ? 'number' : 'phone'"
    step="any"
    :tabindex="tabindex"
    auto-complete="phone"
    :placeholder="$t('general.form_labels.phone')"
    :disabled="disabled"
    class="lad-phone"
  >
    <el-select
      slot="prepend"
      v-model="phone.dial"
      filterable
      :disabled="disabled"
      value-key="dial_code"
      class="lad-phone--flags"
      popper-class="lad-phone"
      :filter-method="handleFilter"
      @blur="handleBlur"
      @change="setDial"
    >
      <template slot="prefix">
        <span v-if="country.flag_code" class="lad-phone--flag">{{
          country.flag_code
        }}</span>
        <img v-else :src="country.flag" class="lad-phone--flag" />
      </template>

      <el-option
        v-for="(item, index) in countriesList"
        :key="index"
        :value="item"
      >
        <span v-if="item.flag_code" class="lad-phone--flag">{{
          item.flag_code
        }}</span>
        <img v-else :src="item.flag" class="lad-phone--flag" />
        <span>{{ item.dial_code }}</span>
        <span>{{ item.alpha_2_code }}</span>
      </el-option>
    </el-select>
  </el-input>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'LadInputPhone',
  props: {
    dial: {
      type: String,
      default: '',
    },
    number: {
      type: [Number, String],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tabindex: { type: String, default: null },
  },
  data() {
    return {
      filter: null,
      phone: {
        number: '',
        dial: '',
      },
      country: {
        flag: '',
        flag_code: '',
      },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('settings', ['countries', 'locale']),
    countriesList() {
      let countriesList = []

      if (this.countries.length) {
        countriesList = this.countries.filter((c) => !!c.dial_code)

        if (this.filter) {
          countriesList = countriesList.filter((c) => {
            return (
              c.dial_code.endsWith(this.filter) ||
              c.alpha_2_code.endsWith(this.filter) ||
              c.alpha_3_code.endsWith(this.filter)
            )
          })
        }
      }

      return countriesList
    },
  },
  watch: {
    number(val) {
      this.phone.number = val
    },
    dial(val) {
      if (val) this.setDialByCode(val)
    },
    'phone.dial'(val) {
      this.$emit('change', this.phone)
    },
    'phone.number'(val) {
      this.cleanPhoneNumber(val)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.number) {
        this.phone.number = this.number
      }

      this.dial ? this.setDialByCode(this.dial) : this.setDefaultDial()
    },
    cleanPhoneNumber(val) {
      this.phone.number = (val || '').replace(/[^0-9]/g, '')

      this.LadNextTick(
        () => this.$emit('change', this.phone),
        'LadInputPhone 1'
      )
    },
    setDialByCode(code) {
      const country = this.countriesList.find((e) => {
        return e.dial_code === code
      })

      if (country) this.setDial(country)
    },
    setDial(country) {
      this.country = {
        flag: country.flag,
        flag_code: country.flag_code,
      }

      this.phone.dial = country.dial_code
    },
    setDefaultDial() {
      const alpha2code = this.locale.split('_')[1] || 'MX'

      const defaultCountry = this.countriesList.find((e) => {
        return e.alpha_2_code === alpha2code
      })

      if (defaultCountry) this.setDial(defaultCountry)
    },
    handleFilter(value) {
      this.phone.dial = value
      this.filter = (value || '').replace(/\+/g, '').toUpperCase()
    },
    handleBlur() {
      this.filter = null

      this.LadNextTick(() => {
        const found = this.countriesList.find((c) => {
          return c.dial_code === this.phone.dial
        })

        if (found) {
          this.country = {
            flag: found.flag,
            flag_code: found.flag_code,
          }
        } else {
          this.setDefaultDial()
        }
      }, 'LadInputPhone 2')
    },
  },
}
</script>

<style lang="scss">
.lad-phone {
  &--flags {
    padding: 0 10px;
    display: block;

    & > div:first-child {
      display: flex !important;
      align-items: baseline;
    }

    .el-input__inner {
      width: 50px;
      padding: 0;
      order: 1;
    }

    .el-input__prefix {
      position: initial;
    }

    .el-input__suffix {
      display: none;
    }
  }

  .el-select-dropdown__empty {
    padding: 10px;
  }

  .el-select-dropdown__item {
    display: grid;
    align-items: center;
    grid-template-columns: auto auto 1fr;
  }

  .el-select-dropdown__item > span:nth-child(3) {
    text-align: right;
    font-size: 12px;
    color: #888;
    margin-left: 10px;
  }

  &--flag {
    margin-right: 10px;
    width: 20px;
  }

  @media screen and (max-width: 420px) {
    &--flags {
      padding: 0 18px;

      .el-input__inner {
        display: none;
      }
    }

    &--flag {
      margin-right: 0;
    }

    .el-select-dropdown__item > span:nth-child(2) {
      margin-left: 10px;
    }
  }
}
</style>
